"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai-assist.suggestions.header': 'AI Suggestions',
    'ai-assist.suggestions.close': 'Close',
    'ai-assist.suggestions.intro': 'Select a suggestion to apply it to your prompt:',
};
